const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 322.933 245.301 L 322.933 200.531 C 322.933 167.624 296.161 140.837 263.239 140.837 C 230.324 140.837 203.543 167.624 203.543 200.531 L 203.543 245.301 C 187.061 245.301 173.697 258.666 173.697 275.149 L 173.697 349.768 C 173.697 366.251 187.061 379.614 203.543 379.614 L 322.933 379.614 C 339.416 379.614 352.78 366.251 352.78 349.768 L 352.78 275.149 C 352.78 258.666 339.416 245.301 322.933 245.301 Z M 270.7 317.631 L 270.7 342.305 C 270.7 346.43 267.362 349.768 263.239 349.768 C 259.114 349.768 255.777 346.43 255.777 342.305 L 255.777 317.631 C 251.397 315.037 248.315 310.462 248.315 304.997 C 248.315 296.747 254.996 290.072 263.239 290.072 C 271.481 290.072 278.162 296.747 278.162 304.997 C 278.162 310.462 275.08 315.037 270.7 317.631 Z M 293.086 245.301 L 233.391 245.301 L 233.391 200.531 C 233.391 184.062 246.777 170.683 263.239 170.683 C 279.693 170.683 293.086 184.063 293.086 200.531 L 293.086 245.301 Z",
    style: {
      stroke: "rgb(255, 255, 255)",
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 561.074 251.18 m -227.639 0 a 227.639 227.064 0 1 0 455.278 0 a 227.639 227.064 0 1 0 -455.278 0 Z M 561.074 251.18 m -212.424 0 a 212.424 213.297 0 0 1 424.848 0 a 212.424 213.297 0 0 1 -424.848 0 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    transform: "matrix(-0.707107, 0.707107, -0.707107, -0.707107, 833.322669, 38.935905)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.cabd337fc8014bded97287513bed3753.svg";
export { ForwardRef as ReactComponent };